import React, { useEffect, useState } from 'react';
import { CnCheckboxGroup, CnRadioGroup } from '@sto/cn-ui';
import { CustomRadioGroup } from '@/components';

interface ICustomCheckBoxProps {
  mode?: 'single' | 'multiple';
  dataSource?: any[];
  size?: 'small' | 'medium' | 'large';
  direction?: 'hoz' | 'ver';
  [key: string]: any;
}

/**
 * 自定义复选框
 * @param dataSource 数据源
 * @param size 大小
 * @param direction 方向
 * @param mode 模式
 * @param value 值
 * @param onChange 变化事件
 * @returns 
 */
const CustomCheckBox = ({
  mode = 'multiple', // single 单选
  defaultValue,
  value,
  onChange,
  ...props
}: ICustomCheckBoxProps) => {
  const [checkValue, setCheckValue] = useState<any>(null);

  useEffect(() => {
    if (value) {
      setCheckValue(value);
    } else {
      setCheckValue(null);
    }
  }, [value]);

  const onCheckChange = (value: any) => {
    onChange(value);
  }

  if (mode === 'single') {
    const { shape, iconUrl, ...restProps } = props || {};
    if (shape === 'tag' && iconUrl) {
      // 标签模式下，展示iconUrl
      const innerAfter = {
        type: 'img',
        content: iconUrl,
      }
      return <CustomRadioGroup
        {...restProps} 
        dataSource={props.dataSource || []}
        value={checkValue} 
        onChange={onCheckChange} 
        innerAfter={innerAfter} 
      />;
    }
    return <CnRadioGroup value={checkValue} onChange={onCheckChange} {...props} />;
  }
  return <CnCheckboxGroup value={checkValue} onChange={onCheckChange} {...props} />;
};

export default CustomCheckBox;